import * as THREE from 'three'
import Experience from '../Experience.js'
import { shareLink } from '../Utils/share.js'

export default class Info {

    constructor() {

        this.experience = new Experience()

        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.world = this.experience.world

        this.info = document.querySelector('.info')
        this.template = document.getElementById('info-card-template')?.innerHTML ?? ''

        this.currentHole = null
        this.currentOpacity = 0
        this.targetOpacity = 0

        this.currentContent = ''

        this.loadInfo()
        this.setDOM()
    }

    loadInfo() {

        this.infoData = this.resources.items.info
    }

    setDOM() {

        this.info.innerHTML = ''

        this.inner = document.createElement('div')
        this.inner.className = 'info__inner'

        this.info.appendChild(this.inner)

        this.info.style.opacity = 0

        this.inner.addEventListener('click', (e) => {
            const share = e.target.closest('.info-card__share')
            if (share) {
                e.stopPropagation()
                this.shareHole(Number(share.dataset.hole))
                return
            }

            const toggle = e.target.closest('.info-card__desc-toggle')
            if (!toggle) return

            e.stopPropagation()

            const wrap = toggle.closest('.info-card__desc-wrap')
            if (!wrap) return

            const expanded = !wrap.classList.contains('is-expanded')

            wrap.classList.toggle('is-expanded', expanded)
            wrap.classList.toggle('is-collapsed', !expanded)
            toggle.setAttribute('aria-expanded', String(expanded))
        })
    }

    applyTemplate(data) {

        return this.template.replace(/{{\s*([\w.]+)\s*}}/g, (_, key) => {
            return data[key] ?? ''
        })
    }

    // Lien direct vers le trou (#trou-7), partagé ou copié
    async shareHole(hole) {
        const timeline = this.experience.timeline
        if (!timeline || !this.infoData[hole]) return

        const result = await shareLink({
            title: `Trou ${hole} · ${this.infoData[hole].nom} — ${document.title}`,
            text: `Découvrez le trou ${hole} du Golf des Hautes Terres en 3D`,
            url: timeline.getHoleUrl(hole)
        })
        if (result === 'copied') this.experience.modeToggle?.showHint(`Lien du trou ${hole} copié`)
    }

    // Longueur relative de chaque départ (barres de distance)
    withTeeRatios(data) {
        const tees = ['white', 'yellow', 'blue', 'red']
        const max = Math.max(...tees.map(tee => Number(data[tee]) || 0)) || 1
        const ratios = {}
        for (const tee of tees) {
            ratios[`${tee}Pct`] = Math.round(((Number(data[tee]) || 0) / max) * 100)
        }
        return { ...data, ...ratios }
    }

    // Met en avant la ligne du départ choisi
    syncSelectedTee(force = false) {
        const selected = this.experience.teeSelection?.selectedColor ?? null
        if (!force && selected === this.selectedTee) return
        this.selectedTee = selected

        for (const row of this.inner.querySelectorAll('.info-card__tee')) {
            row.classList.toggle('is-selected', row.dataset.tee === selected)
        }
        this.inner.querySelector('.info-card')?.classList.toggle('has-selection', selected != null)
    }

    setContent(data) {

        if (!data) return

        const html = this.applyTemplate(this.withTeeRatios(data))

        if (html === this.currentContent) return

        this.currentContent = html

        this.inner.innerHTML = html
        this.resetDescriptionPanel()
        this.syncSelectedTee(true)
    }

    resetDescriptionPanel() {

        const wrap = this.inner.querySelector('.info-card__desc-wrap')
        const toggle = wrap?.querySelector('.info-card__desc-toggle')

        if (!wrap) return

        wrap.classList.add('is-collapsed')
        wrap.classList.remove('is-expanded')
        toggle?.setAttribute('aria-expanded', 'false')
    }

    setInfo(hole) {

        if (this.currentHole === hole) return

        this.currentHole = hole

        const data = this.infoData[hole]

        if (!data) {
            this.targetOpacity = 0
            return
        }

        //
        // fade out avant remplacement
        //
        this.targetOpacity = 0

        clearTimeout(this.swapTimeout)

        this.swapTimeout = setTimeout(() => {

            this.setContent(data)

            //
            // fade in
            //
            this.targetOpacity = 1

        }, 250)
    }

    //
    // transition synchronisée avec RAF
    //
    update() {

        this.syncSelectedTee()

        this.currentOpacity += (this.targetOpacity - this.currentOpacity) * 0.08

        this.info.style.opacity = this.currentOpacity
        this.info.style.transform = `translateY(${12 * (1 - this.currentOpacity)}px)`

    }

    clearHighlight() {

        this.currentHole = null
        this.targetOpacity = 0
    }

    destroy() {

        clearTimeout(this.swapTimeout)

        this.info.innerHTML = ''
    }
}